import React from "react";
import { useNavigate } from "react-router-dom";
import ModalNew from "../../../../../components/ui/popup/Modal";
import {
  PopupContent,
  PopupHeader,
  PopupSection,
} from "../../../../../components/ui/popup/common";

const CpaCompletionModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  return (
    <ModalNew className="content-modal" style={{ maxWidth: "480px" }}>
      <PopupHeader
        title="Filing Completed Successfully"
        setOpenState={onClose}
        icon={`${process.env.PUBLIC_URL}/images/icons/survey_blue_popup.svg`}
        variant="compact"
        hideCloseButton={true}
      />
      <PopupContent>
        <PopupSection>
          The tax filing for this client has been successfully completed. Your
          payment is now being processed and will be included in the next payout
          cycle.
        </PopupSection>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "12px",
            flexWrap: "wrap",
            marginTop: "12px",
          }}
        >
          <button
            type="button"
            className="cta-button primary short text-center"
            onClick={() => {
              onClose();
              navigate("/tax-filing?segment=jobs");
            }}
          >
            My Jobs
          </button>
          <button
            type="button"
            className="cta-button secondary short text-center"
            onClick={() => {
              onClose();
              navigate("/");
            }}
          >
            Home
          </button>
        </div>
      </PopupContent>
    </ModalNew>
  );
};

export default CpaCompletionModal;
